import React from "react";
import PropTypes from "prop-types";
import { Row, Col } from "reactstrap";
import SpotsInfo from "./spots-info";

const propTypes = {
  campaignPackage: PropTypes.shape({
    packageLabel: PropTypes.string,
    packageDetails: PropTypes.string,
    startsAt: PropTypes.string,
    endsAt: PropTypes.string,
    newRenewalPlan: PropTypes.string,
    renewalDate: PropTypes.string
  }).isRequired,
  purchasedZips: PropTypes.arrayOf(
    PropTypes.shape({
      postal_code: PropTypes.string,
      count: PropTypes.number,
      category: PropTypes.string
    })
  )
};

const CampaignDetails = ({ campaignPackage, purchasedZips = [] }) => {
  const CATEGORY_LABELS = {
    web: "Web",
    mobile: "Mobile",
    web_and_mobile: "Web & Mobile",
    digital_out_of_home: "Digital Out-of-Home",
    tv: "TV"
  };

  const durationDisplay = ({ startsAt, endsAt }) => {
    if (endsAt && startsAt) {
      return (
        <div className="font-weight-bold">
          {startsAt} - {endsAt}
        </div>
      );
    }
    if (startsAt) {
      return <div className="font-weight-bold">Start: {startsAt}</div>;
    }
    return <div className="font-weight-bold">TBD</div>;
  };

  const zipsByCategory = purchasedZips.reduce((acc, zip) => {
    const existing = acc[zip.category] || [];
    return { ...acc, [zip.category]: [...existing, zip] };
  }, {});

  const spotGroups = Object.entries(zipsByCategory).map(([category, zips]) => ({
    category,
    label: CATEGORY_LABELS[category] || category,
    totalCount: zips.reduce((sum, z) => sum + z.count, 0),
    zips
  }));

  return (
    <>
      <h6 className="text-uppercase font-weight-semibold font-size-small mb-3">Campaign Details</h6>
      <div className="campaign-card-section background-light-blue p-2 mb-3">
        <Row>
          {campaignPackage.packageLabel && (
            <Col xs="12" md="6" className="my-2">
              <div className="text-uppercase font-size-small font-weight-semibold text-muted mb-1">
                Package
              </div>
              <div className="font-weight-bold">{campaignPackage.packageLabel}</div>
              {campaignPackage.packageDetails && (
                <div className="font-size-small text-muted mt-1">
                  {campaignPackage.packageDetails}
                </div>
              )}
            </Col>
          )}
          <Col xs="12" md="6" className="my-2">
            <div className="text-uppercase font-size-small font-weight-semibold text-muted mb-1">
              Duration
            </div>
            {durationDisplay(campaignPackage)}
          </Col>
          {spotGroups.length > 0 && (
            <Col xs="12" md="6" className="my-2">
              <div className="text-uppercase font-size-small font-weight-semibold text-muted mb-1">
                Zip Codes
              </div>
              {spotGroups.map(group => (
                <SpotsInfo
                  key={group.category}
                  label={group.label}
                  totalCount={group.totalCount}
                  zips={group.zips}
                />
              ))}
            </Col>
          )}
          {campaignPackage.renewalDate && (
            <Col xs="12" md="6" className="my-2">
              {campaignPackage.newRenewalPlan ? (
                <div className="text-uppercase font-size-small font-weight-semibold text-muted mb-1">
                  Converts to {campaignPackage.newRenewalPlan} on
                </div>
              ) : (
                <div className="text-uppercase font-size-small font-weight-semibold text-muted mb-1">
                  Renews
                </div>
              )}
              <div className="font-weight-bold">{campaignPackage.renewalDate}</div>
            </Col>
          )}
        </Row>
      </div>
    </>
  );
};

CampaignDetails.propTypes = propTypes;

export default CampaignDetails;
